import { object, string } from 'yup';

export const schema = () => {
  return object().shape({
    message: string().required(),
  });
};
